module.exports = __webpack_public_path__ + "img/safe-travel.8d30729.png";


//////////////////
// WEBPACK FOOTER
// ./static/img_link/safe-travel.png
// module id = m/y+
// module chunks = 1